import { useCallback } from "react";
import ScheduleDiagram from ".";
import { applyScheduleChange } from "./schedule";

// The "Scheduled" popover of an Item: the timeline of the open form (values:
// the form values the Item publishes; formRef: its Formik). A drag changes
// the values of the form (conditionRaw, condition and scheduling of the
// statement, scheduling and schedulingMap of the item), which the form's Save
// saves: nothing is written from here, and the user's unsaved edits stay.
export default function FormScheduleDiagram({ itemType, values, formRef }) {
  const onChange = useCallback(
    (rowId, change) => {
      const formik = formRef.current;
      if (!formik || formik.values?.id !== rowId) return;

      // From the live values of the form, in one setValues: Formik validates
      // a setFieldValue with the values of its last render, so with one call
      // per path the later validations (and the values the Item publishes)
      // would miss the earlier changes.
      const next = applyScheduleChange(formik.values, change);
      if (next !== formik.values) formik.setValues(next);
    },
    [formRef]
  );

  return (
    <ScheduleDiagram itemType={itemType} rows={values} onChange={onChange} />
  );
}
